const STORAGE_EMPRESA_LOGIN = "i9.empresa-login-selecionada";

export function lerEmpresaLoginSelecionada(): string {
  try {
    return String(window.localStorage.getItem(STORAGE_EMPRESA_LOGIN) || "").trim();
  } catch {
    return "";
  }
}

export function salvarEmpresaLoginSelecionada(codEmpresa: string): void {
  try {
    window.localStorage.setItem(STORAGE_EMPRESA_LOGIN, String(codEmpresa || "").trim());
  } catch {
    /* armazenamento opcional */
  }
}
